import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DSIcon } from '@spotahome/ui-library/base';

import './ListingTag.scss';

const ListingTag = ({
  icon,
  description = null,
  name,
  hasBackground = false,
  descriptionClassName = '',
  isNotIncluded = false
}) => {
  const listingTagClassName = classNames('listing-tag', {
    'listing-tag--background': hasBackground,
    'listing-tag--not-included': isNotIncluded
  });

  return (
    <div className={listingTagClassName}>
      <DSIcon name={icon} title={icon} className="listing-tag__icon" />

      <div className="listing-tag__name">
        <span className="listing-tag__text">{name}</span>
        {description && (
          <span className={descriptionClassName}>{description}</span>
        )}
      </div>
    </div>
  );
};

ListingTag.propTypes = {
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  hasBackground: PropTypes.bool,
  descriptionClassName: PropTypes.string,
  isNotIncluded: PropTypes.bool
};

export default ListingTag;
